
export default {
  name: 'ReusableToolTip',

  props: {
    content: {
      type: String,
      required: true,
      default: '',
    },
  },

  computed: {
    setting() {
      return {
        content: this.content,
        html: true,
        triggers: ['click', 'hover', 'touch'],
        placement: 'top',
        distance: '20',
        theme: 'info-menu',
      };
    },
  },
};
